import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { Form, Divider, Row, Col, Button } from 'antd';
import AntIcon from '../../shared/components/AntIcon';

import { renderInput } from '../../shared/utils/form_components';
import { required, url } from '../../shared/utils/form_validations';

import BuyLinkFields from './BuyLinkFields';

const ColorwayFields = ({ fields, label }) => {
  return (
    <div>
      {fields.map((link, index, fields) => (
        <div key={link}>
          <Row gutter={8}>
            <Col span={8}>
              <Field
                name={`${link}.nickname`}
                label="Nickname"
                placeholder="Nickname"
                component={renderInput}
                required
                validate={required}
              />
            </Col>
            <Col span={14}>
              <Field
                name={`${link}.image`}
                label="Image"
                placeholder="Image"
                component={renderInput}
                required
                validate={[required, url]}
              />
            </Col>
            <Col>
              <Form.Item className="is-right">
                <AntIcon
                  type="minus-circle-o"
                  onClick={() => fields.remove(index)}
                  style={{ cursor: 'pointer', color: 'red', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={20}>
              <FieldArray label="Links" name={`${link}.links`} component={BuyLinkFields} />
            </Col>
          </Row>

          <Divider dashed style={{ marginTop: 0 }} />
        </div>
      ))}

      <Form.Item>
        <Button type="dashed" onClick={() => fields.push({})} style={{ width: '60%', float: 'center' }}>
          <AntIcon type="plus" />Add Colorway
        </Button>
      </Form.Item>
    </div>
  );
}

export default ColorwayFields;
